import { Header } from "basis";
import { getRegional } from "library/getRegional";
import { useMemo, useReducer } from "react";
import { HardshipFooter } from "./Footer/HardshipFooter";
import { useRedirect } from "./hooks/useRedirect";
import { HardshipApplicationContext } from "./reducer/context";
import { hardshipReducer } from "./reducer/hardshipReducer";
import { initialState } from "./reducer/initialState";
import { basePath } from "./routes/constants";
import { HardshipApplicationRoutes } from "./routes/HardshipApplicationRoutes";

export const HardshipApplication = () => {
  const [state, dispatch] = useReducer(hardshipReducer, initialState);

  const contextValue = useMemo(() => ({ state, dispatch }), [state, dispatch]);

  useRedirect({
    state,
    shouldBlock: (pathname) => !pathname.includes("hardship"),
    basePath,
  });

  const regionCode = getRegional("code");

  return (
    <HardshipApplicationContext.Provider value={contextValue}>
      <Header>
        <Header.Logo name={regionCode === "AU" ? "latitude" : "gem"} />
      </Header>
      <HardshipApplicationRoutes />
      <HardshipFooter />
    </HardshipApplicationContext.Provider>
  );
};
